import { InfoOutlined } from "@mui/icons-material";
import { IconButton, Popover } from "@mui/material";
import { Box } from "@mui/system";
import { ReactNode, useState } from "react";

export function InfoSlot({ children }: { children: ReactNode }) {
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLButtonElement | null>(
    null
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        paddingTop: "2px",
      }}
    >
      <>
        <IconButton
          onClick={(e) => setPopoverAnchor(e.target as HTMLButtonElement)}
        >
          <InfoOutlined />
        </IconButton>
        <Popover
          open={!!popoverAnchor}
          anchorEl={popoverAnchor}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          onClose={() => setPopoverAnchor(null)}
        >
          {children}
        </Popover>
      </>
    </Box>
  );
}
